import React, { useContext, useState } from 'react';
import Tab from 'components/common/Tab';
import { constant } from 'constants/constant';
import OwnDriver from '../OwnDriver';
import MarketDriver from '../MarketDriver';
import { ButtonHeading } from 'components';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';

const Driver = () => {
    useDocumentTitle("Driver | T360");
    const [activeTab, setActiveTab] = useState(1);
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const { mastersChild } = useContext(UserContext);
    const masterChildDriver = mastersChild?.find((i) => i?.label === "Driver");

    const [filter, setFilter] = useState({
        search: '',
      });

    const tabProps = {
        tabList: constant.driverTabs,
        callBackTab: (e) => setActiveTab(e),
        activeTab: activeTab
    };

    const toggleOffcanvas = (data) => {
        setShowOffcanvas(data);
    };

    return (
        <div>
            <ButtonHeading
                title="Driver"
                buttonTitle={masterChildDriver?.create === 1 && (activeTab === 1 ? "Add Own Driver" : "Add Market Driver")}
                onClick={() => toggleOffcanvas(true)}
                showSearchFilter={{ search: true, filterOption: false, filterCount: true }}
                filter={filter}
                setFilter={setFilter}
                isDebouncedSearch={false}
                listDownload={true}
            />
            <div className='addPr_flBx'>
                <Tab {...tabProps} />
                {activeTab === 1 && (
                    <OwnDriver showOffcanvas={showOffcanvas} toggleOffcanvas={toggleOffcanvas} listSearch={{...filter}}/>
                )}

                {activeTab === 2 && (
                    <MarketDriver showOffcanvas={showOffcanvas} toggleOffcanvas={toggleOffcanvas} listSearch={{...filter}}/>
                )}
            </div>
        </div>
    );
}

export default Driver;
